<template>
  <div
    class="errorBox"
    :class="{ black: this.pageName.indexOf('selectie') === 1 }"
  >
    <div class="box">
      <div class="wrapper">
        <p class="error">{{ defaultMessage }} {{ errorMessage }}</p>
      </div>
      <img
        v-if="this.pageName.indexOf('selectie') === -1"
        class="close"
        @click="hide"
        src="../assets/Icons/close.svg"
      />
      <img
        v-if="this.pageName.indexOf('selectie') === 1"
        class="close"
        @click="hide"
        src="../assets/Icons/close-white.svg"
      />
    </div>
  </div>
</template>

<script>
// export default {
//   props: {
//     defaultMessage: String,
//     errorMessage: String,
//     black: {
//       type: Boolean,
//       default: false,
//     },
//   },
//   data() {
//     return {
//       pageName: this.$route.path,
//     };
//   },
//   methods: {
//     hide() {
//       this.$emit("hide");
//     },
//   },
// };

import { ref, onMounted, defineEmits, defineProps } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "YourComponentName",
  setup() {
    // Define props using defineProps
    const props = defineProps({
      defaultMessage: {
        type: String,
        default: "",
      },
      errorMessage: {
        type: String,
        default: "",
      },
      black: {
        type: Boolean,
        default: false,
      },
    });

    // Define emits using defineEmits
    const emit = defineEmits(["hide"]);

    // Define reactive data
    const pageName = ref("");

    // Initialize the pageName with the current route path
    const route = useRoute();
    onMounted(() => {
      pageName.value = route.path;
    });

    // Define the hide method
    const hide = () => {
      emit("hide");
    };

    // Return all reactive data and methods to expose them to the template
    return {
      props,
      pageName,
      hide,
    };
  },
};
</script>

<style lang="sass" scoped></style>
